export const authQueryKeys = {
  all: ['auth'] as const,
  user: () => [...authQueryKeys.all, 'user'] as const,
  session: () => [...authQueryKeys.all, 'session'] as const
};

export const userQueryKeys = {
  all: ['user'] as const,
  byId: (id: string) => [...userQueryKeys.all, id] as const,
  projects: (id: string) => [...userQueryKeys.all, id, 'projects'] as const
};
